import React, { useContext } from 'react';
import styles from './index.module.scss';
import { DataLayerEventContext } from '../../../contexts/dataLayerEventContext';
import { getImageFromS3 } from '../../../imageService';

const HomeScreen = () => {
  const { sendEvent } = useContext(DataLayerEventContext);

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.headContainer}>
          <img className={styles.headBg} src={getImageFromS3('images/sms-prl-rvmp/head-bg.png')} alt="head-bg" />
          <img className={styles.logo} src={getImageFromS3('images/sms-prl-rvmp/logo.png')} alt="logo" />
          <p className={styles.headTitle}>НЕЗМІННА ЯКІСТЬ в ОНОВЛЕНОМУ дизайні*</p>
          <img className={styles.pack} src={getImageFromS3('images/sms-prl-rvmp/pack.png')} alt="pack" />
          <div className={styles.disclaimer}>
            *Змінюється лише дизайн пачки. Характеристики сигарет (фільтр, тютюн та формат) залишаються незмінними.
          </div>
        </div>
        <div className={styles.formatContainer}>
          <img className={styles.formatBg} src={getImageFromS3('images/sms-prl-rvmp/format-bg.png')} alt="format-bg" />
          <p>“Кінг Сайз” Стандарт формат</p>
          <div className={styles.characteristicsContainer}>
            <div>
              <img src={getImageFromS3('images/sms-prl-rvmp/filter.png')} alt="filter" />
              <p>
                <b>Recessed 2.0</b><br />
                фільтр з повітряною камерою
              </p>
            </div>
            <div>
              <img src={getImageFromS3('images/sms-prl-rvmp/tobacco.png')} alt="tobacco" />
              <p>
                <b>Тютюнова суміш</b><br />
                від Parliament
              </p>
            </div>
          </div>
          <img className={styles.packs} src={getImageFromS3('images/sms-prl-rvmp/packs.png')} alt="packs" />
        </div>
        <div className={styles.buyContainer}>
          <p className={styles.buyTitle}>Де купити?</p>
          <p className={styles.buyDescription}>
            Актуальний асортимент можна знайти у роздрібних точках продажу в твоєму місті або на офіційних онлайн сервісах, зокрема:
          </p>
          <div className={styles.buttonContainer}>
            <a
              href="https://rozetka.com.ua/ua/sigareti/c4638591/price=1800-1800;producer=parliament/?utm_source=PMUsmsRevamp"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.buttonItem}
              onClick={() => sendEvent('rozetka')}
            >
              <p>Rozetka</p>
              <img src={getImageFromS3('images/sms-prl-rvmp/glass.png')} alt="glass" />
            </a>
            <a
              href="https://cig-poshta.in.ua/shop/parliament/?utm_source=CDAsmsRevamp"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.buttonItem}
              onClick={() => sendEvent('cig-poshta')}
            >
              <p>Cig-poshta</p>
              <img src={getImageFromS3('images/sms-prl-rvmp/glass.png')} alt="glass" />
            </a>
          </div>
        </div>
      </div>
      <div className={styles.footer}>
        Куріння викликає<br />серйозні<br />захворювання та<br />залежність<br />Дана інформація про<br />
        продукт надається<br />відповідно<br />до статті 15 Закону<br />України «Про захист<br />
        прав споживачів»
      </div>
      <div className={styles.unsubscribe}>
        Ти отримав(-ла) повідомлення, оскільки залишав(-ла) запит на отримання
        інформації про продукцію компаній Philip Morris в Україні. <br />
        <a href="/unsubscribe?returnLink=25-sms-prl-line">
          Відписатися від SMS тут.
        </a>
      </div>
    </div>
  );
};

export default HomeScreen;
